import { configureStore } from "@reduxjs/toolkit";
import levelReducer from "./levelSlice";
import deviceReducer from "./deviceSlice";
import citiesReducer from "./citiesSlice";

export const store = configureStore({
  reducer: {
    level: levelReducer,
    device: deviceReducer,
    cities: citiesReducer,
  },
});
